import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { getColor, getSize } from '@lib/common';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  vertical-align: middle;\n  margin: 0 2px;\n"])));
var IndexCircle = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: 1;\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'), getColor('fillIntActive'), getColor('fillBgWhite'), getSize('typo12'));
var StyledAnswerPill = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  background-color: ", ";\n  border: 1.5px solid ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  line-height: 1.6;\n"])), getColor('successBgActive'), getColor('successHighlighted'), getSize('radiusSm'), getSize('typo14'), getColor('successActive'));
export var FillInBlankAnswerReport = function FillInBlankAnswerReport(_ref) {
  var index = _ref.index,
      answerId = _ref.answerId,
      answer = _ref.answer;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(IndexCircle, {
      children: index
    }), answer.description.split('|').map(function (part, idx) {
      return /*#__PURE__*/_jsx(StyledAnswerPill, {
        children: part.trim()
      }, idx);
    })]
  });
};